module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/logo-ef15bc02ba7da784b6704fc612a84a08.svg&quot;;"